import React from 'react';
const api_key = 'http://kong-proxy.kong.svc.cluster.local/api/consultadanfe';

class HelloForm extends React.Component {


    state = {
        texto: ''
    };

    handleTextChange(e) {
        this.setState({
            texto: e.target.value
        });
    }

    handleClick() {
        alert(this.state.texto);
        
    };



    componentDidMount() {
        console.log(this.state.texto)
        fetch(api_key)
            .then(res => res.json())
            .then(res => {
                this.setState({
                    rows: res
                });
            }).catch(erro => {
              console.log( erro );
            });
    }

    render() {
        return (
            <div>
                Digite o texto: <input type="text" onChange={this.handleTextChange.bind(this)}></input>
                <div>{this.state.texto}</div>
                <button onClick={this.handleClick.bind(this)}>Exibir alerta</button>
            </div>
        )
    }
}

export default HelloForm;